/**
 * created by yxy
 * 此组件为列表组件
 * 引用此组件需要传dataSource，columns，start,size
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Input} from 'antd';

const {TextArea} = Input;


export default class InputNumber extends Component {
    static defaultProps = {
        value: "",
        disabled: false,
        placeholder: "请输入申请原因",
        rows:4,
        display:'block',
        maxlength:100,
        onChange: () => {
            console.log(1)
        },

    };
    static propTypes = {
        value: PropTypes.array.isRequired,//输入框里面的内容
        disabled: PropTypes.bool,//输入框是否必填
        placeholder: PropTypes.string,//输入框的placeholder
        rows: PropTypes.number,//最大显示几行
        onChange: PropTypes.func.isRequired,//点击页数的方法
        maxlength: PropTypes.string,//最多可以输入多少字
        display:PropTypes.bool,//是否显示
    };

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div style={{width:667,border:'1px solid  #d9d9d9'}}>
                    <TextArea
                        value={this.props.value}
                        disabled={this.props.disabled}
                        placeholder={this.props.placeholder}
                        rows={this.props.rows}
                        onChange={(e) => {
                            this.props.onChange(e)
                        }}
                        style={{border:'none',resize:'none',overflow: 'hidden'}}
                    />

                {/*<div style={{position: "absolute", bottom: 0, right: '10px', display: this.props.display,width:'auto'}}>*/}
                {/*    <span>{this.props.value.length}</span>*/}
                {/*    <span>/</span>*/}
                {/*    <span>{this.props.maxlength}</span>*/}
                {/*</div>*/}
            </div>
        )
    }

}
